import { TableProps } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Table,
  Tag,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { DatevNumberStatusesEnum } from '@thinknet-gmbh/platform-common';

import { DATEV_MODALS } from 'src/pages/settings/components/datev/datev.constants';

import DatevTableRowActions from './datev-list-table-row-actions.component';
import { StyledTable } from './datev-list-table.styles';

const DatevListTable = ({
  dataSource,
  handleModal,
  onChange,
  pagination,
  consultantNumberId,
}: {
  dataSource: any[];
  handleModal: (modal: string, record: any) => void;
  consultantNumberId: string;
} & TableProps<any>) => {
  const { t } = useTranslation(['common', 'settings', 'employee']);

  return (
    <StyledTable
      t={t}
      dataSource={dataSource}
      rowKey={record => record._id}
      pagination={pagination}
      onChange={onChange}
      footer={() => (
        <Button
          icon={ICONS.plus}
          iconColor={PLATFORM_THEME_COLORS.primary.blue}
          type="text"
          onClick={() => handleModal(DATEV_MODALS.create, { consultantNumberId })}
        >
          {t('settings:datev.buttons.createNumber')}
        </Button>
      )}
    >
      <Table.Column
        width={250}
        title={t('settings:datev.labels.clientNumber')}
        key="datevNumber"
        dataIndex="datevNumber"
        render={number => <Typography>{number}</Typography>}
        sorter={(a: any, b: any) => a.datevNumber - b.datevNumber}
      />
      <Table.Column
        title={t('employee:labels.details')}
        key="details"
        dataIndex="details"
        render={details => <Typography>{details || '-'}</Typography>}
      />
      <Table.Column
        title={t('common:labels.status')}
        key="status"
        width={100}
        dataIndex="status"
        render={status => (
          <Tag
            background={
              status === DatevNumberStatusesEnum.ASSIGNED
                ? PLATFORM_THEME_COLORS.tone.lightGreen
                : PLATFORM_THEME_COLORS.tone.lightBlue
            }
            fontColor={
              status === DatevNumberStatusesEnum.ASSIGNED
                ? PLATFORM_THEME_COLORS.tone.green
                : PLATFORM_THEME_COLORS.primary.blue
            }
          >
            {t(`settings:datev.labels.datevNumberStatuses.${status.toLowerCase()}`)}
          </Tag>
        )}
      />
      <Table.Column
        title={t('common:labels.action')}
        width={50}
        render={record => <DatevTableRowActions record={record} handleModal={handleModal} t={t} />}
      />
    </StyledTable>
  );
};

export default DatevListTable;
